import script from "./UploadBox.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadBox.vue?vue&type=script&setup=true&lang=js"

import "./UploadBox.vue?vue&type=style&index=0&id=f733cea4&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f733cea4"]])

export default __exports__